<template>
  <fields-list
    :fields="fields"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import { mapActions } from "vuex";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";

export default {
  name: "MaterialFieldsCassette",

  components: {
    FieldsList,
  },

  mixins: [listsMixin, objectManagementMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    familySpecificFields: {
      type: Array | Object,
      required: true
    },

    editingData: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      fiberTypeOptions: null
    };
  },

  /**
   * Executed when the component is mounted
   * It's a preemptive verification
   *
   */
  mounted() {
    this.loadFiberTypeoptions();
  },

  watch: {
    editingData() {
      this.requiredFieldsFilled();
    }
  },

  computed: {
    fields() {
      return [
        {
          label: this.$i18n.t("Capacity") + " (" + this.$i18n.tc("Fiber", 2) + ")",
          value: this.familySpecificFields.smct_capacity,
          varName: 'smct_capacity',
          inputType: 'number',
          disabled: false,
          required: true,
          step: '1',
          min: '1'
        },
        {
          label: this.$i18n.t("FiberType"),
          value: !this.editingData
            ? this.parseSelectValue([this.familySpecificFields.smct_fiber_type], this.fiberTypeOptions)
            : this.familySpecificFields.smct_fiber_type,
          varName: 'smct_fiber_type',
          inputType: 'select',
          disabled: false,
          required: true,
          options: this.fiberTypeOptions,
          clearable: true,
          size: '100%',
        },
      ]
    }
  },

  methods: {
    ...mapActions(["GET_LIST"]),

    async loadFiberTypeoptions() {
      try {
        this.fiberTypeOptions = await this.GET_LIST({
          listName: "list_fo_logical_type",
          code: this.familySpecificFields.smct_fiber_type,
          includeDeleted: true
        });
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return (
        !!this.familySpecificFields.smct_capacity && !!this.familySpecificFields.smct_capacity >= 1 &&
        !!this.familySpecificFields.smct_fiber_type
      );
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsCassette.vue